import styles from '../assets/css/custom-buttons.module.css';

export default function CustomButtons({
  children,
  leftLabel = "戻る",
  rightLabel = "登録する",
  onLeftClick,
  onRightClick,
  leftClassName = "btn-primary",
  rightClassName = "btn-primary",
  rightDisabled = false,
  rightLoading = false,
  rightLoadingLabel = "",
  rightType = "button"
}) {
  return (
    <div className={styles['d-grid']}>
      {children ? (
        children
      ) : (
        <>
          <button
            onClick={onLeftClick}
            className={`${styles.btn} ${styles['btn-secondary']} ${leftClassName}`}
          >
            {leftLabel}
          </button>
          <button
            type={rightType}
            onClick={onRightClick}
            disabled={rightDisabled}
            className={`${styles.btn} ${styles['btn-secondary']} ${rightClassName}`}
          >
            {rightLoading ? (rightLoadingLabel || rightLabel) : rightLabel}
          </button>
        </>
      )}
    </div>
  );
}